<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          FBA No：{{ formData.amzFbaShipmentNo || '' }}
        </span>
        <el-divider
          direction="vertical"
          v-if="formData.v_amzFbaShipmentStatus"
        ></el-divider>
        <b-badge
          v-if="formData.v_amzFbaShipmentStatus"
          style="font-size: 12px"
          :variant="
            formData.amzFbaShipmentStatus === 'N' ||
            formData.amzFbaShipmentStatus === 'Y'
              ? 'primary'
              : formData.amzFbaShipmentStatus === 'C'
              ? 'success'
              : formData.amzFbaShipmentStatus === 'D'
              ? 'danger'
              : 'warning'
          "
        >
          {{ formData.v_amzFbaShipmentStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :span="6">
          <span style="font-size: 14px">{{ $l('form_label_amzPeriodTitle') || '补货计划' }}：{{ formData.amzPeriodTitle }}</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 14px">{{ $l('form_label_shipmentDate') || '出运日期' }}：{{ formData.shipmentDate }}</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 14px">{{ $l('form_label_shipmentQty') || '产品数量' }}：{{ formData.shipmentQty }}</span>
        </el-col>
        <el-col :span="6">
          <span style="font-size: 14px">{{ $l('form_label_shipmentAmount') || '合计金额' }}：{{ formData.shipmentAmount }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <span style="font-size: 14px">{{ $l('INDEX.table_label_remarks') || '备注说明' }}：{{ formData.remark }}</span>
        </el-col>
      </el-row>
    </div>

    <DetailTable :amzFbaShipmentCode="amzFbaShipmentCode" />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import DetailTable from '../detail-table'
export default {
  mixins: [EditLoading],
  components: {DetailTable},
  props: {
    disabled: Boolean,
    amzFbaShipmentCode: String,
    params: {type: Object, default: () => {}},
  },
  data() {
    return {
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.amzFbaShipmentCode) return

      this.$api
        .ecomAmzFbaShipmentDetailApi({
          amzFbaShipmentCode: this.amzFbaShipmentCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
